import React, { useState } from 'react';
import {
  Button, TextField, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Divider, Paper, Box, Typography,
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, Done as DoneIcon, Cancel as CancelIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function FileRequestForm(props) {
  const { t } = useTranslation();
  // const [requestedFiles, setRequestedFiles] = useState([]);
  const [currentDescription, setCurrentDescription] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [showInput, setShowInput] = useState(false); // Control whether to show the input field
  const [isMandatory, setIsMandatory] = useState(true);

  const handleAddFileRequest = () => {
    if (currentDescription.trim() !== '') {
      props.setRequestedFiles([
        ...props.requestedFiles,
        { description: currentDescription, mandatory: isMandatory },
      ]);
      setCurrentDescription('');
      setIsMandatory(true);
      setShowInput(false);
    }

    console.log([
      ...props.requestedFiles,
      { description: currentDescription, mandatory: isMandatory },
    ]);
  };

  const handleEditFileRequest = (index) => {
    setEditingIndex(index);
    setCurrentDescription(props.requestedFiles[index].description);
    setIsMandatory(props.requestedFiles[index].mandatory);
    setShowInput(true);
  };

  const handleSaveEdit = () => {
    if (currentDescription.trim() !== '') {
      const updatedFiles = [...props.requestedFiles];
      updatedFiles[editingIndex] = { description: currentDescription, mandatory: isMandatory };
      props.setRequestedFiles(updatedFiles);
      setCurrentDescription('');
      setIsMandatory(true);
      setEditingIndex(null);
      setShowInput(false);
    }
  };

  const handleCancelEdit = () => {
    setCurrentDescription('');
    setEditingIndex(null);
    setShowInput(false); // Hide the input field after canceling edit
  };

  const handleDeleteFileRequest = (index) => {
    const updatedFiles = [...props.requestedFiles];
    updatedFiles.splice(index, 1);
    props.setRequestedFiles(updatedFiles);
  };

  return (
    <Box sx={{ marginBottom: 3 }}>
      <Typography variant="h6" sx={{ marginBottom: 3, fontWeight: 600 }}>
        {t('createTemplate.fileRequestForm.title')}
      </Typography>
      {!showInput && (
        <Box sx={{ marginBottom: 2 }}>
          <Button variant="contained" endIcon={<AddIcon />} onClick={() => setShowInput(true)}>
            {t('createTemplate.fileRequestForm.addButton')}
          </Button>
        </Box>
      )}
      {showInput && (
        <Box sx={{ marginBottom: 2 }}>
          <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
            <TextField
              label={t('createTemplate.fileRequestForm.descriptionLabel')}
              variant="outlined"
              fullWidth
              value={currentDescription}
              onChange={(e) => setCurrentDescription(e.target.value)}
              sx={{ marginBottom: 2 }}
            />
            <Box>
              <label>
                {t('createTemplate.fileRequestForm.mandatory')}
                <input
                  className="m-3"
                  type="checkbox"
                  checked={isMandatory}
                  onChange={(e) => setIsMandatory(e.target.checked)}
                />
              </label>
            </Box>
          </Paper>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {editingIndex !== null ? (
              <>
                <Button variant="contained" endIcon={<DoneIcon />} onClick={handleSaveEdit}>
                  {t('createTemplate.fileRequestForm.done')}
                </Button>
                <Button variant="contained" endIcon={<CancelIcon />} onClick={handleCancelEdit}>
                  {t('createTemplate.fileRequestForm.cancel')}
                </Button>
              </>
            ) : (
              <>
                <Button variant="contained" endIcon={<AddIcon />} onClick={handleAddFileRequest}>
                  {t('createTemplate.fileRequestForm.add')}
                </Button>
                <Button variant="contained" endIcon={<CancelIcon />} onClick={() => setShowInput(false)}>
                  {t('createTemplate.fileRequestForm.cancel')}
                </Button>
              </>
            )}
          </Box>
        </Box>
      )}

      {props.requestedFiles.length > 0 && (
        <Box>
          <List>
            <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
              {props.requestedFiles.map((file, index) => (
                <React.Fragment key={index}>
                  <ListItem key={index}>
                    <ListItemText primary={file.description} />
                    <ListItemSecondaryAction>
                      <IconButton edge="end" onClick={() => handleEditFileRequest(index)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton edge="end" onClick={() => handleDeleteFileRequest(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {index !== props.requestedFiles.length - 1 && <Divider sx={{ margin: '8px 0' }} />}
                </React.Fragment>
              ))}
            </Paper>
          </List>
        </Box>
      )}
    </Box>
  );
}

export default FileRequestForm;
